import React from 'react';

import './module-title-text.scss';

interface ModuleTitleTextProps {
  top: string;
  bottom?: string;
}

const ModuleTitleText: React.FC<ModuleTitleTextProps> = ({ top, bottom }) => (
  <div className="module-title-text">
    <div className="module-title-text__top">{top}</div>
    {bottom && <div className="module-title-text__bottom">{bottom}</div>}
  </div>
);

export default ModuleTitleText;
